import React, { useContext, useId, useState } from "react";
import { useLanguage } from "../../contexts/LanguageContext";
import { csvText, fileSlug, saveBlob } from "../../utils/csvFile";
import DataTable from "./DataTable";
import { DownloadPeriodContext } from "./downloadPeriod";
import InfoTip from "./InfoTip";
import Legend from "./Legend";

// A moldura de cada grafico: titulo, nota, legenda (so quando a recebe: as barras de uma serie nao
// passam nenhuma, mas uma barra empilhada com uma so chave precisa do nome), o botao que troca o
// grafico pela tabela e o que descarrega a tabela. A tabela e obrigatoria (spec do RPAA-286, decisao
// 12), e e tambem a saida para quem nao ve as cores. Com `tableOnly` os filhos ja sao a tabela: some o
// botao que as trocava e fica o descarregar.
//
// `table` e { columns, rows } na forma do DataTable, com os valores em bruto nas linhas. O ficheiro (entrega
// 5 do redesign) leva-os assim, sem formatacao, com os rotulos das colunas e das linhas como a tabela os
// mostra; uma coluna com `skipInDownload` fica so na tabela, e uma com `downloadOnly` so no ficheiro (o
// dia do periodo anterior da evolucao, que o ecra diz na legenda e a folha de calculo precisa). O nome do
// ficheiro e o `downloadName` (um grafico com escolha diz qual) ou o titulo, mais o periodo da pagina.
const ChartFrame = ({ title, note, lead, info, actions, legend, table, tableOnly, downloadName, empty, children }) => {
  const { translate } = useLanguage();
  const [showTable, setShowTable] = useState(false);
  const headingId = useId();
  const period = useContext(DownloadPeriodContext);

  const download = () => {
    const columns = table.columns.filter((column) => !column.skipInDownload);
    const name = [fileSlug(downloadName || title), period].filter(Boolean).join("-");
    saveBlob(new Blob([csvText(columns, table.rows)], { type: "text/csv;charset=utf-8" }), `${name}.csv`);
  };

  let body;
  if (empty) {
    body = (
      <p className="text-sm" style={{ color: "var(--color-text-muted)" }}>
        {translate("analyticsNoData")}
      </p>
    );
  } else if (showTable) {
    body = <DataTable caption={title} columns={table.columns} rows={table.rows} />;
  } else {
    body = (
      <>
        {legend && legend.length > 0 && (
          <div className="mb-2">
            <Legend items={legend} />
          </div>
        )}
        {children}
      </>
    );
  }

  const link = { color: "var(--color-text-secondary)" };
  return (
    <figure
      aria-labelledby={headingId}
      className="rounded-xl border p-4 m-0"
      style={{ borderColor: "var(--color-border)", backgroundColor: "var(--color-surface)" }}
    >
      <div className="flex flex-wrap items-start justify-between gap-3 mb-3">
        <div>
          <div className="flex items-center gap-1">
            <h3 id={headingId} className="text-sm font-semibold" style={{ color: "var(--color-text-primary)" }}>
              {title}
            </h3>
            {info && <InfoTip text={info} label={translate("analyticsAbout", { title })} />}
          </div>
          {note && (
            <p className="text-xs mt-1" style={{ color: "var(--color-text-secondary)" }}>
              {note}
            </p>
          )}
        </div>
        <div className="flex flex-wrap items-center gap-3">
          {actions}
          {!empty && table && (
            <>
              {!tableOnly && (
                <button type="button" onClick={() => setShowTable((shown) => !shown)} className="text-xs underline shrink-0" style={link}>
                  {showTable ? translate("analyticsShowChart") : translate("analyticsShowTable")}
                </button>
              )}
              <button type="button" onClick={download} className="text-xs underline shrink-0" style={link}>
                {translate("analyticsDownloadTable")}
              </button>
            </>
          )}
        </div>
      </div>
      {lead && !empty && (
        <p className="text-sm mb-3" style={{ color: "var(--color-text-primary)" }}>
          {lead}
        </p>
      )}
      {body}
    </figure>
  );
};

export default ChartFrame;
